// // components/Invitations.jsx
// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import { 
//   FaSearch, 
//   FaEnvelope, 
//   FaRedo, 
//   FaTrash,
//   FaFilter,
//   FaTimes,
//   FaArrowLeft
// } from 'react-icons/fa';
// import { 
//   Clock, 
//   CheckCircle, 
//   XCircle, 
//   Send,
//   Calendar,
//   Building,
//   MoreVertical,
//   Mail,
//   Phone,
//   UserPlus,
//   Briefcase
// } from 'lucide-react';
// import Pagination from '../helpers/Pagination';
// import SelectDropdown from '../customStyles/SelectDropdown';
// import api from '../common/apiClient';
// import SummaryApi from '../common/SummaryApi';
// import { formatDateTime } from '../helpers/formatDateTime';
// import InvitationSkeleton from '../components/SkeletonComponents/InvitationSkeleton';


// const InvitationPage = () => {
//   const { portalName } = useParams();
//   const navigate = useNavigate();
//   const filterRef = useRef(null);
  
//   // States
//   const [invitations, setInvitations] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [showFilters, setShowFilters] = useState(false);
//   const [selectedInvitations, setSelectedInvitations] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(null);
  
//   // Filter states
//   const [filters, setFilters] = useState({
//     status: '',
//     role: '',
//     divisionId: '',
//     departmentId: '',
//     startDate: '',
//     endDate: ''
//   });
  
//   // Dropdown options
//   const [divisions, setDivisions] = useState([]);
//   const [departments, setDepartments] = useState([]);
//   const [roles, setRoles] = useState([]);
  
//   // Pagination states
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalItems, setTotalItems] = useState(0);

//   // Status options
//   const statusOptions = [
//     { id: '', label: 'All Status' },
//     { id: 'pending', label: 'Pending' },
//     { id: 'accepted', label: 'Accepted' },
//     { id: 'expired', label: 'Expired' }
//   ];

//   // Fetch dropdown options
//   const fetchDropdownOptions = useCallback(async () => {
//     try {
//       const [divisionsRes, departmentsRes, rolesRes] = await Promise.all([
//         api.get(SummaryApi.getAllDivisions.url),
//         api.get(SummaryApi.getAllDepartments.url),
//         api.get(SummaryApi.getAllRoles.url)
//       ]);

//       setDivisions([
//         { _id: '', name: 'All Divisions' },
//         ...(divisionsRes.data.data || [])
//       ]);
      
//       setDepartments([
//         { _id: '', name: 'All Departments' },
//         ...(departmentsRes.data.data || [])
//       ]);
      
//       setRoles([
//         { _id: '', roleName: 'All Roles' },
//         { _id: 'owner', roleName: 'Owner' },
//         ...(rolesRes.data.data || [])
//       ]);
//     } catch (error) {
//       console.error('Error fetching options:', error);
//     }
//   }, []);

//   // Fetch invitations
//   const fetchInvitations = useCallback(async () => {
//     setLoading(true);
//     try {
//       const queryParams = new URLSearchParams({
//         page: currentPage,
//         limit: itemsPerPage === 'All' ? 1000 : itemsPerPage,
//         status: filters.status || '',
//         ...filters
//       });

//       // Remove empty params
//       for (let key of queryParams.keys()) {
//         if (!queryParams.get(key)) {
//           queryParams.delete(key);
//         }
//       }

//       const response = await api.get(`${SummaryApi.getAllInvitations.url}?${queryParams}`);
      
//       if (response.data.success) {
//         setInvitations(response.data.data || []);
//         setTotalItems(response.data.total || 0);
//       }
//     } catch (error) {
//       console.error('Error fetching invitations:', error);
//       toast.error('Failed to fetch invitations');
//     } finally {
//       setLoading(false);
//     }
//   }, [currentPage, itemsPerPage, filters]);

//   useEffect(() => {
//     fetchDropdownOptions();
//   }, [fetchDropdownOptions]);

//   useEffect(() => {
//     fetchInvitations();
//   }, [fetchInvitations]);

//   // Handle search
//   const filteredInvitations = invitations.filter((invitation) => {
//     const query = searchTerm.toLowerCase();
//     return (
//       invitation.email?.toLowerCase().includes(query) ||
//       invitation.firstName?.toLowerCase().includes(query) ||
//       invitation.lastName?.toLowerCase().includes(query) ||
//       `${invitation.firstName} ${invitation.lastName}`.toLowerCase().includes(query)
//     );
//   });

//   // Handle filter change
//   const handleFilterChange = (name, value) => {
//     setFilters(prev => ({ ...prev, [name]: value }));
//     setCurrentPage(1);
//   };

//   // Reset filters
//   const handleResetFilters = () => {
//     setFilters({
//       status: '',
//       role: '',
//       divisionId: '',
//       departmentId: '',
//       startDate: '',
//       endDate: ''
//     });
//     setSearchTerm('');
//     setCurrentPage(1);
//   };

//   // Resend invitation
//   const handleResendInvitation = async (id) => {
//     try {
//       // If SummaryApi.resendInvitation doesn't exist, use the direct URL
//       const url = SummaryApi.resendInvitation?.url(id);
//       const response = await api.post(url);
//       if (response.data.success) {
//         toast.success('Invitation resent successfully');
//         fetchInvitations();
//         setShowDropdown(null);
//       }
//     } catch (error) {
//       toast.error(error.response?.data?.message || 'Failed to resend invitation');
//     }
//   };

//   // Cancel invitation
//   const handleCancelInvitation = async (id) => {
//     if (!window.confirm('Are you sure you want to cancel this invitation?')) return;
    
//     try {
//       // If SummaryApi.deleteInvitation doesn't exist, use the direct URL

        
//     const url = SummaryApi.deleteInvitation?.url(id)
//       const response = await api.delete(url);
//       if (response.data.success) {
//         toast.success('Invitation cancelled successfully');
//         fetchInvitations();
//         setShowDropdown(null);
//       }
//     } catch (error) {
//       toast.error(error.response?.data?.message || 'Failed to cancel invitation');
//     }
//   };

//   // Toggle selection
//   const toggleSelection = (id) => {
//     setSelectedInvitations(prev => 
//       prev.includes(id) 
//         ? prev.filter(item => item !== id)
//         : [...prev, id]
//     );
//   };

//   // Select all
//   const handleSelectAll = () => {
//     if (selectedInvitations.length === filteredInvitations.length) {
//       setSelectedInvitations([]);
//     } else {
//       setSelectedInvitations(filteredInvitations.map(inv => inv._id));
//     }
//   };

//   // Get status color
//   const getStatusBadge = (status) => {
//     const badges = {
//       pending: (
//         <span className="inline-flex items-center px-2 py-1 text-xs font-medium bg-yellow-100 text-yellow-700 rounded-full">
//           <span className="w-1.5 h-1.5 bg-yellow-500 rounded-full mr-1"></span>
//           Pending
//         </span>
//       ),
//       accepted: (
//         <span className="inline-flex items-center px-2 py-1 text-xs font-medium bg-green-100 text-green-700 rounded-full">
//           <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-1"></span>
//           Accepted
//         </span>
//       ),
//       expired: (
//         <span className="inline-flex items-center px-2 py-1 text-xs font-medium bg-red-100 text-red-700 rounded-full">
//           <span className="w-1.5 h-1.5 bg-red-500 rounded-full mr-1"></span>
//           Expired
//         </span>
//       )
//     };
//     return badges[status] || badges.pending;
//   };

//   // Get initials
//   const getInitials = (firstName, lastName) => {
//     return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase() || 'U';
//   };

//   // Get role badge color
//   const getRoleBadgeColor = (role) => {
//     const colors = {
//       owner: 'bg-purple-100 text-purple-700 border-purple-200',
//       admin: 'bg-red-100 text-red-700 border-red-200',
//       manager: 'bg-blue-100 text-blue-700 border-blue-200',
//       default: 'bg-gray-100 text-gray-700 border-gray-200'
//     };
//     return colors[role?.toLowerCase()] || colors.default;
//   };

//   // Close filters on outside click
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (filterRef.current && !filterRef.current.contains(event.target)) {
//         setShowFilters(false);
//       }
//       if (showDropdown && !event.target.closest('.dropdown-container')) {
//         setShowDropdown(null);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, [showDropdown]);

//   const handleBackClick = () => {
//     navigate(-1);
//   };

//   const hasActiveFilters = Object.values(filters).filter(v => v).length > 0 || searchTerm;

//   const clearAllFilters = () => {
//     handleResetFilters();
//   };

//     if (loading && filteredInvitations.length === 0) {
//       return <InvitationSkeleton />;
//     }

//   return (
//     <div className="">
//       {/* Header */}
//       <div className="mb-6">
//         <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
//           <div className="flex items-center gap-4">
//             <button
//               onClick={handleBackClick}
//               className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
//               aria-label="Go back"
//             >
//               <FaArrowLeft className="h-5 w-5" />
//             </button>
//             <div>
//               <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 flex items-center gap-2">
//                 <FaEnvelope className="h-7 w-7 text-red-600" />
//                 Team Invitations
//               </h1>
//               <p className="text-gray-600 mt-1">Manage pending invitations and track team member onboarding</p>
//             </div>
//           </div>
//           <button
//             onClick={() => navigate(`/${portalName}/settings/users/add`)}
//             className="flex items-center gap-2 bg-gradient-to-r from-red-600 to-pink-600 text-white px-4 py-2 rounded-lg hover:from-red-700 hover:to-pink-700 transition-all transform hover:scale-105 shadow-lg"
//           >
//             <UserPlus className="h-5 w-5" />
//             <span>Invite Member</span>
//           </button>
//         </div>
//       </div>

//       {/* Stats Cards */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
//         <div className="bg-gradient-to-br from-yellow-50 to-orange-50 border border-yellow-200 rounded-xl p-6">
//           <div className="flex items-center justify-between">
//             <div>
//               <p className="text-sm text-yellow-600 font-medium">Pending</p>
//               <p className="text-2xl font-bold text-gray-900 mt-1">
//                 {invitations.filter(i => i.status === 'pending').length}
//               </p>
//             </div>
//             <Clock className="w-10 h-10 text-yellow-500" />
//           </div>
//         </div>

//         <div className="bg-gradient-to-br from-green-50 to-emerald-50 border border-green-200 rounded-xl p-6">
//           <div className="flex items-center justify-between">
//             <div>
//               <p className="text-sm text-green-600 font-medium">Accepted</p>
//               <p className="text-2xl font-bold text-gray-900 mt-1">
//                 {invitations.filter(i => i.status === 'accepted').length}
//               </p>
//             </div>
//             <CheckCircle className="w-10 h-10 text-green-500" />
//           </div>
//         </div>

//         <div className="bg-gradient-to-br from-red-50 to-pink-50 border border-red-200 rounded-xl p-6">
//           <div className="flex items-center justify-between">
//             <div>
//               <p className="text-sm text-red-600 font-medium">Expired</p>
//               <p className="text-2xl font-bold text-gray-900 mt-1">
//                 {invitations.filter(i => i.status === 'expired').length}
//               </p>
//             </div>
//             <XCircle className="w-10 h-10 text-red-500" />
//           </div>
//         </div>

//         <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-6">
//           <div className="flex items-center justify-between">
//             <div>
//               <p className="text-sm text-blue-600 font-medium">Total Sent</p>
//               <p className="text-2xl font-bold text-gray-900 mt-1">
//                 {invitations.length}
//               </p>
//             </div>
//             <Send className="w-10 h-10 text-blue-500" />
//           </div>
//         </div>
//       </div>

//       {/* Search and Filters */}
//       <div className="mb-6 space-y-4">
//         <div className="flex flex-col sm:flex-row gap-4">
//           <div className="relative flex-1">
//             <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
//             <input
//               type="text"
//               placeholder="Search by name, email..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
//             />
//           </div>
          
//           <button
//             onClick={() => setShowFilters(!showFilters)}
//             className={`flex items-center gap-2 px-4 py-2 border rounded-lg transition-colors ${
//               hasActiveFilters 
//                 ? 'bg-red-50 border-red-300 text-red-700' 
//                 : 'border-gray-300 hover:bg-gray-50'
//             }`}
//           >
//             <FaFilter className="h-5 w-5" />
//             <span>Filters</span>
//             {hasActiveFilters && (
//               <span className="bg-red-600 text-white text-xs px-2 py-0.5 rounded-full">
//                 {Object.values(filters).filter(v => v).length + (searchTerm ? 1 : 0)}
//               </span>
//             )}
//           </button>
//         </div>

//         {/* Filter Panel */}
//         {showFilters && (
//           <div className="bg-white p-4 rounded-lg shadow-sm border space-y-4">
//             <div className="flex items-center justify-between mb-2">
//               <h3 className="font-medium text-gray-900">Filters</h3>
//               {hasActiveFilters && (
//                 <button
//                   onClick={clearAllFilters}
//                   className="text-sm text-red-600 hover:text-red-700 flex items-center gap-1"
//                 >
//                   <FaTimes className="h-4 w-4" />
//                   Clear all
//                 </button>
//               )}
//             </div>
            
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
//               <SelectDropdown
//                 label="Status"
//                 options={statusOptions}
//                 value={filters.status}
//                 onChange={(value) => handleFilterChange('status', value)}
//                 labelKey="label"
//                 valueKey="id"
//                 placeholder="All Status"
//               />

//               <SelectDropdown
//                 label="Role"
//                 options={roles}
//                 value={filters.role}
//                 onChange={(value) => handleFilterChange('role', value)}
//                 labelKey="roleName"
//                 valueKey="_id"
//                 placeholder="All Roles"
//                 searchable
//               />

//               <SelectDropdown
//                 label="Division"
//                 options={divisions}
//                 value={filters.divisionId}
//                 onChange={(value) => handleFilterChange('divisionId', value)}
//                 labelKey="name"
//                 valueKey="_id"
//                 placeholder="All Divisions"
//                 searchable
//               />

//               <SelectDropdown
//                 label="Department"
//                 options={departments}
//                 value={filters.departmentId}
//                 onChange={(value) => handleFilterChange('departmentId', value)}
//                 labelKey="name"
//                 valueKey="_id"
//                 placeholder="All Departments"
//                 searchable
//               />

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Start Date
//                 </label>
//                 <input
//                   type="date"
//                   name="startDate"
//                   value={filters.startDate}
//                   onChange={(e) => handleFilterChange('startDate', e.target.value)}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   End Date
//                 </label>
//                 <input
//                   type="date"
//                   name="endDate"
//                   value={filters.endDate}
//                   onChange={(e) => handleFilterChange('endDate', e.target.value)}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
//                 />
//               </div>

//               <div className="sm:col-span-2 flex items-end gap-2">
//                 <button
//                   onClick={fetchInvitations}
//                   className="px-6 py-2 bg-gradient-to-r from-red-500 to-pink-500 text-white rounded-lg hover:from-red-600 hover:to-pink-600 transition-all transform hover:scale-105 shadow-lg"
//                 >
//                   Apply Filters
//                 </button>
//                 <button
//                   onClick={handleResetFilters}
//                   className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-all"
//                 >
//                   Reset
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Bulk Actions */}
//       {selectedInvitations.length > 0 && (
//         <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 flex items-center justify-between">
//           <div className="flex items-center gap-3">
//             <span className="text-blue-700 font-medium">
//               {selectedInvitations.length} invitation(s) selected
//             </span>
//           </div>
//           <div className="flex gap-2">
//             <button 
//               className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
//               onClick={() => {
//                 // Implement bulk resend
//                 toast.info('Bulk resend feature coming soon');
//               }}
//             >
//               Resend Selected
//             </button>
//             <button 
//               className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
//               onClick={() => {
//                 // Implement bulk cancel
//                 toast.info('Bulk cancel feature coming soon');
//               }}
//             >
//               Cancel Selected
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Table */}
//       {loading ? (
//         <InvitationSkeleton />
//       ) : filteredInvitations.length === 0 ? (
//         <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-12 text-center">
//           <FaEnvelope className="w-16 h-16 text-gray-300 mx-auto mb-4" />
//           <h3 className="text-lg font-semibold text-gray-900 mb-2">
//             No invitations found
//           </h3>
//           <p className="text-gray-500 mb-6">
//             {searchTerm 
//               ? "Try adjusting your search or filters"
//               : "Start inviting team members to collaborate"
//             }
//           </p>
//           <button
//             onClick={() => navigate(`/${portalName}/settings/users/add`)}
//             className="px-6 py-3 bg-gradient-to-r from-red-500 to-pink-500 text-white rounded-lg hover:from-red-600 hover:to-pink-600 transition-all transform hover:scale-105 shadow-lg"
//           >
//             Invite Team Member
//           </button>
//         </div>
//       ) : (
//         <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
//           <div className="overflow-x-auto">
//             <table className="w-full min-w-[1400px] relative">
//               <thead className="bg-gradient-to-r from-red-50 to-pink-50 border-b">
//                 <tr>
//                   <th className="sticky left-0 z-10 bg-gradient-to-r from-red-50 to-pink-50">
//                     <div className="px-4 sm:px-6 py-3 flex items-center">
//                       <input
//                         type="checkbox"
//                         checked={selectedInvitations.length === filteredInvitations.length && filteredInvitations.length > 0}
//                         onChange={handleSelectAll}
//                         className="w-4 h-4 text-red-600 border-gray-300 rounded focus:ring-red-500"
//                       />
//                       <span className="ml-4 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
//                         User
//                       </span>
//                     </div>
//                   </th>
//                   <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
//                     Contact
//                   </th>
//                   <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
//                     Role
//                   </th>
//                   <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
//                     Department
//                   </th>
//                   <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
//                     Division
//                   </th>
//                   <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
//                     Status
//                   </th>
//                   <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
//                     Invited By
//                   </th>
//                   <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
//                     <div className="flex items-center gap-1">
//                       <Calendar className="h-3.5 w-3.5" />
//                       Dates
//                     </div>
//                   </th>
//                   <th className="px-4 sm:px-6 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">
//                     Actions
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-200">
//                 {filteredInvitations.map((invitation) => (
//                   <tr key={invitation._id} className="hover:bg-gray-50 transition-colors">
//                     <td className="sticky left-0 z-10 bg-white">
//                       <div className="px-4 sm:px-6 py-4 flex items-center">
//                         <input
//                           type="checkbox"
//                           checked={selectedInvitations.includes(invitation._id)}
//                           onChange={() => toggleSelection(invitation._id)}
//                           className="w-4 h-4 text-red-600 border-gray-300 rounded focus:ring-red-500"
//                         />
//                         <div className="ml-4 flex items-center">
//                           {invitation.profilePicture ? (
//                             <img
//                               src={invitation.profilePicture}
//                               alt={`${invitation.firstName} ${invitation.lastName}`}
//                               className="w-10 h-10 rounded-full object-cover"
//                             />
//                           ) : (
//                             <div className="w-10 h-10 rounded-full bg-gradient-to-br from-red-500 to-pink-500 flex items-center justify-center text-white font-bold text-sm">
//                               {getInitials(invitation.firstName, invitation.lastName)}
//                             </div>
//                           )}
//                           <div className="ml-3 sm:ml-4">
//                             <div className="text-sm font-medium text-gray-900">
//                               {invitation.firstName} {invitation.lastName}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </td>
//                     <td className="px-4 sm:px-6 py-4">
//                       <div className="text-sm text-gray-900 flex items-center">
//                         <Mail className="h-3.5 w-3.5 mr-1 text-gray-400" />
//                         <span className="truncate max-w-[200px]">{invitation.email}</span>
//                       </div>
//                       {invitation.mobile && (
//                         <div className="text-sm text-gray-500 flex items-center mt-1">
//                           <Phone className="h-3.5 w-3.5 mr-1 text-gray-400" />
//                           {invitation.mobile}
//                         </div>
//                       )}
//                     </td>
//                     <td className="px-4 sm:px-6 py-4 whitespace-nowrap">
//                       <span className={`px-2 sm:px-3 py-1 text-xs font-medium rounded-full border ${getRoleBadgeColor(invitation.role)}`}>
//                         {invitation.role}
//                       </span>
//                     </td>
//                     <td className="px-4 sm:px-6 py-4">
//                       <div className="text-sm text-gray-900 flex items-center">
//                         <Building className="h-3.5 w-3.5 mr-1 text-gray-400" />
//                         {invitation.departmentId?.name || '-'}
//                       </div>
//                     </td>
//                     <td className="px-4 sm:px-6 py-4">
//                       <div className="text-sm text-gray-900 flex items-center">
//                         <Briefcase className="h-3.5 w-3.5 mr-1 text-gray-400" />
//                         {invitation.divisionId?.name || '-'}
//                       </div>
//                     </td>
//                     <td className="px-4 sm:px-6 py-4 whitespace-nowrap">
//                       {getStatusBadge(invitation.status)}
//                     </td>
//                     <td className="px-4 sm:px-6 py-4">
//                       <div className="text-sm space-y-1">
//                         <div className="text-gray-900 flex items-center">
//                           <UserPlus className="h-3.5 w-3.5 mr-1 text-gray-400" />
//                           <span className="text-xs">
//                             {invitation.invitedBy?.firstName} {invitation.invitedBy?.lastName}
//                           </span>
//                         </div>
//                       </div>
//                     </td>
//                     <td className="px-4 sm:px-6 py-4">
//                       <div className="text-sm space-y-1">
//                         <div className="text-gray-700">
//                           Invited: {formatDateTime(invitation.createdAt, false)}
//                         </div>
//                         {invitation.status === 'pending' && (
//                           <div className="text-orange-600 text-xs">
//                             Expires: {formatDateTime(invitation.expiresAt, false)}
//                           </div>
//                         )}
//                         {invitation.status === 'accepted' && invitation.acceptedAt && (
//                           <div className="text-green-600 text-xs">
//                             Accepted: {formatDateTime(invitation.acceptedAt, false)}
//                           </div>
//                         )}
//                       </div>
//                     </td>
//                     <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-center">
//                       <div className="relative dropdown-container">
//                         <button
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             setShowDropdown(showDropdown === invitation._id ? null : invitation._id);
//                           }}
//                           className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
//                         >
//                           <MoreVertical className="h-5 w-5 text-gray-500" />
//                         </button>
                        
//                         {showDropdown === invitation._id && (
//                           <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border z-20">
//                             {invitation.status === 'pending' && (
//                               <button
//                                 onClick={() => handleResendInvitation(invitation._id)}
//                                 className="flex items-center gap-2 w-full px-4 py-2 text-sm text-blue-700 hover:bg-gray-50 rounded-t-lg"
//                               >
//                                 <FaRedo className="h-4 w-4" />
//                                 Resend Invitation
//                               </button>
//                             )}
//                             <button
//                               onClick={() => handleCancelInvitation(invitation._id)}
//                               className={`flex items-center gap-2 w-full px-4 py-2 text-sm text-red-700 hover:bg-gray-50 ${
//                                 invitation.status !== 'pending' ? 'rounded-lg' : 'rounded-b-lg'
//                               }`}
//                             >
//                               <FaTrash className="h-4 w-4" />
//                               Cancel Invitation
//                             </button>
//                           </div>
//                         )}
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
          
//           {/* Mobile scroll indicator */}
//           <div className="sm:hidden bg-gray-50 px-4 py-2 text-center text-xs text-gray-500">
//             ← Scroll horizontally to see more →
//           </div>
//         </div>
//       )}

//       {/* Pagination */}
//       {filteredInvitations.length > 0 && (
//         <div className="mt-8">
//           <Pagination
//             totalItems={totalItems}
//             itemsPerPage={itemsPerPage}
//             currentPage={currentPage}
//             onPageChange={setCurrentPage}
//             onItemsPerPageChange={(value) => {
//               setItemsPerPage(value);
//               setCurrentPage(1);
//             }}
//           />
//         </div>
//       )}
//     </div>
//   );
// };

// export default InvitationPage;


// components/Invitations.jsx
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { 
  FaSearch, 
  FaEnvelope, 
  FaRedo, 
  FaTrash,
  FaFilter,
  FaTimes,
  FaArrowLeft
} from 'react-icons/fa';
import { 
  Clock, 
  CheckCircle, 
  XCircle, 
  Send,
  Calendar,
  Building,
  MoreVertical,
  Mail,
  Phone,
  UserPlus,
  Briefcase
} from 'lucide-react';
import Pagination from '../helpers/Pagination';
import SelectDropdown from '../customStyles/SelectDropdown';
import api from '../common/apiClient';
import SummaryApi from '../common/SummaryApi';
import { formatDateTime } from '../helpers/formatDateTime';
import InvitationSkeleton from '../components/SkeletonComponents/InvitationSkeleton';

const InvitationPage = () => {
  const { portalName } = useParams();
  const navigate = useNavigate();
  const filterRef = useRef(null);
  
  // States
  const [invitations, setInvitations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [selectedInvitations, setSelectedInvitations] = useState([]);
  const [showDropdown, setShowDropdown] = useState(null);
  
  // Filter states
  const [filters, setFilters] = useState({
    status: '',
    role: '',
    divisionId: '',
    departmentId: '',
    startDate: '',
    endDate: ''
  });
  
  // Dropdown options
  const [divisions, setDivisions] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [roles, setRoles] = useState([]);
  
  // Pagination states
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  // Status options
  const statusOptions = [
    { id: '', label: 'All Status' },
    { id: 'pending', label: 'Pending' },
    { id: 'accepted', label: 'Accepted' },
    { id: 'expired', label: 'Expired' }
  ];

  // Fetch dropdown options
  const fetchDropdownOptions = useCallback(async () => {
    try {
      const [divisionsRes, departmentsRes, rolesRes] = await Promise.all([
        api.get(SummaryApi.getAllDivisions.url),
        api.get(SummaryApi.getAllDepartments.url),
        api.get(SummaryApi.getAllRoles.url)
      ]);

      setDivisions([
        { _id: '', name: 'All Divisions' },
        ...(divisionsRes.data.data || [])
      ]);
      
      setDepartments([
        { _id: '', name: 'All Departments' },
        ...(departmentsRes.data.data || [])
      ]);
      
      setRoles([
        { _id: '', roleName: 'All Roles' },
        { _id: 'owner', roleName: 'Owner' },
        ...(rolesRes.data.data || [])
      ]);
    } catch (error) {
      console.error('Error fetching options:', error);
    }
  }, []);

  // Fetch invitations
  const fetchInvitations = useCallback(async () => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams({
        page: currentPage,
        limit: itemsPerPage === 'All' ? 1000 : itemsPerPage,
        status: filters.status || '',
        ...filters
      });

      // Remove empty params
      for (let key of queryParams.keys()) {
        if (!queryParams.get(key)) {
          queryParams.delete(key);
        }
      }

      const response = await api.get(`${SummaryApi.getAllInvitations.url}?${queryParams}`);
      
      if (response.data.success) {
        setInvitations(response.data.data || []);
        setTotalItems(response.data.total || 0);
      }
    } catch (error) {
      console.error('Error fetching invitations:', error);
      toast.error('Failed to fetch invitations');
    } finally {
      setLoading(false);
    }
  }, [currentPage, itemsPerPage, filters]);

  useEffect(() => {
    fetchDropdownOptions();
  }, [fetchDropdownOptions]);

  useEffect(() => {
    fetchInvitations();
  }, [fetchInvitations]);

  // Handle search
  const filteredInvitations = invitations.filter((invitation) => {
    const query = searchTerm.toLowerCase();
    return (
      invitation.email?.toLowerCase().includes(query) ||
      invitation.firstName?.toLowerCase().includes(query) ||
      invitation.lastName?.toLowerCase().includes(query) ||
      `${invitation.firstName} ${invitation.lastName}`.toLowerCase().includes(query)
    );
  });

  // Handle filter change
  const handleFilterChange = (name, value) => {
    setFilters(prev => ({ ...prev, [name]: value }));
    setCurrentPage(1);
  };

  // Reset filters
  const handleResetFilters = () => {
    setFilters({
      status: '',
      role: '',
      divisionId: '',
      departmentId: '',
      startDate: '',
      endDate: ''
    });
    setSearchTerm('');
    setCurrentPage(1);
  };

  // Resend invitation
  const handleResendInvitation = async (id) => {
    try {
      const url = SummaryApi.resendInvitation?.url(id);
      const response = await api.post(url);
      if (response.data.success) {
        toast.success('Invitation resent successfully');
        fetchInvitations();
        setShowDropdown(null);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to resend invitation');
    }
  };

  // Cancel invitation
  const handleCancelInvitation = async (id) => {
    if (!window.confirm('Are you sure you want to cancel this invitation?')) return;
    
    try {
      const url = SummaryApi.deleteInvitation?.url(id);
      const response = await api.delete(url);
      if (response.data.success) {
        toast.success('Invitation cancelled successfully');
        fetchInvitations();
        setShowDropdown(null);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to cancel invitation');
    }
  };

  // Toggle selection
  const toggleSelection = (id) => {
    setSelectedInvitations(prev => 
      prev.includes(id) 
        ? prev.filter(item => item !== id)
        : [...prev, id]
    );
  };

  // Select all
  const handleSelectAll = () => {
    if (selectedInvitations.length === filteredInvitations.length) {
      setSelectedInvitations([]);
    } else {
      setSelectedInvitations(filteredInvitations.map(inv => inv._id));
    }
  };

  // Get status color
  const getStatusBadge = (status) => {
    const badges = {
      pending: (
        <span className="inline-flex items-center px-2 py-1 text-xs font-medium bg-yellow-100 text-yellow-700 rounded-full">
          <span className="w-1.5 h-1.5 bg-yellow-500 rounded-full mr-1"></span>
          Pending
        </span>
      ),
      accepted: (
        <span className="inline-flex items-center px-2 py-1 text-xs font-medium bg-green-100 text-green-700 rounded-full">
          <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-1"></span>
          Accepted
        </span>
      ),
      expired: (
        <span className="inline-flex items-center px-2 py-1 text-xs font-medium bg-red-100 text-red-700 rounded-full">
          <span className="w-1.5 h-1.5 bg-red-500 rounded-full mr-1"></span>
          Expired
        </span>
      )
    };
    return badges[status] || badges.pending;
  };

  // Get initials
  const getInitials = (firstName, lastName) => {
    return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase() || 'U';
  };

  // Get role badge color
  const getRoleBadgeColor = (role) => {
    const colors = {
      owner: 'bg-purple-100 text-purple-700 border-purple-200',
      admin: 'bg-red-100 text-red-700 border-red-200',
      manager: 'bg-blue-100 text-blue-700 border-blue-200',
      default: 'bg-gray-100 text-gray-700 border-gray-200'
    };
    return colors[role?.toLowerCase()] || colors.default;
  };

  // Close filters on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setShowFilters(false);
      }
      if (showDropdown && !event.target.closest('.dropdown-container')) {
        setShowDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showDropdown]);

  const handleBackClick = () => {
    navigate(-1);
  };

  const hasActiveFilters = Object.values(filters).filter(v => v).length > 0 || searchTerm;

  const clearAllFilters = () => {
    handleResetFilters();
  };

  // Show skeleton when loading and no data
  if (loading && invitations.length === 0) {
    return <InvitationSkeleton />;
  }

  return (
    <div className="p-4">
      <div className="">
        {/* Header */}
        <div className="mb-6">
          <div className="flex  justify-between items-start sm:items-center gap-4">
            <div className="flex items-center gap-4">
              <button
                onClick={handleBackClick}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                aria-label="Go back"
              >
                <FaArrowLeft className="h-5 w-5" />
              </button>
              <div>
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 flex items-center gap-2">
                  Team Invitations
                </h1>
              </div>
            </div>
            <button
              disabled
              onClick={() => navigate(`/${portalName}/invitations/invite`)}
              className="flex items-center gap-2 bg-gradient-to-r from-red-600 to-pink-600 text-white px-4 py-2 rounded-lg hover:from-red-700 hover:to-pink-700 transition-all transform hover:scale-105 shadow-lg"
            >
              <UserPlus className="h-5 w-5" />
              <span className='hidden sm:inline'>Invite Member</span>
              <span className='sm:hidden'>Invite</span>
            </button>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
          <div className="bg-gradient-to-br from-yellow-50 to-orange-50 border border-yellow-200 rounded-xl p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-yellow-600 font-medium">Pending</p>
                <p className="text-2xl font-bold text-gray-900 mt-1">
                  {invitations.filter(i => i.status === 'pending').length}
                </p>
              </div>
              <Clock className="w-10 h-10 text-yellow-500" />
            </div>
          </div>

          <div className="bg-gradient-to-br from-green-50 to-emerald-50 border border-green-200 rounded-xl p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-green-600 font-medium">Accepted</p>
                <p className="text-2xl font-bold text-gray-900 mt-1">
                  {invitations.filter(i => i.status === 'accepted').length}
                </p>
              </div>
              <CheckCircle className="w-10 h-10 text-green-500" />
            </div>
          </div>

          <div className="bg-gradient-to-br from-red-50 to-pink-50 border border-red-200 rounded-xl p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-red-600 font-medium">Expired</p>
                <p className="text-2xl font-bold text-gray-900 mt-1">
                  {invitations.filter(i => i.status === 'expired').length}
                </p>
              </div>
              <XCircle className="w-10 h-10 text-red-500" />
            </div>
          </div>

          <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-blue-600 font-medium">Total Sent</p>
                <p className="text-2xl font-bold text-gray-900 mt-1">
                  {invitations.length}
                </p>
              </div>
              <Send className="w-10 h-10 text-blue-500" />
            </div>
          </div>
        </div>

        {/* Search and Filters */}
        <div className="mb-6 space-y-4">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="relative flex-1">
              <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
              <input
                type="text"
                placeholder="Search by name, email..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
              />
            </div>
            
            <button
              onClick={() => setShowFilters(!showFilters)}
              className={`flex items-center gap-2 px-4 py-2 border rounded-lg transition-colors ${
                hasActiveFilters 
                  ? 'bg-red-50 border-red-300 text-red-700' 
                  : 'border-gray-300 hover:bg-gray-50'
              }`}
            >
              <FaFilter className="h-5 w-5" />
              <span>Filters</span>
              {hasActiveFilters && (
                <span className="bg-red-600 text-white text-xs px-2 py-0.5 rounded-full">
                  {Object.values(filters).filter(v => v).length + (searchTerm ? 1 : 0)}
                </span>
              )}
            </button>
          </div>

          {/* Filter Panel */}
          {showFilters && (
            <div ref={filterRef} className="bg-white p-4 rounded-lg shadow-sm border space-y-4">
              <div className="flex items-center justify-between mb-2">
                <h3 className="font-medium text-gray-900">Filters</h3>
                {hasActiveFilters && (
                  <button
                    onClick={clearAllFilters}
                    className="text-sm text-red-600 hover:text-red-700 flex items-center gap-1"
                  >
                    <FaTimes className="h-4 w-4" />
                    Clear all
                  </button>
                )}
              </div>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                <SelectDropdown
                  label="Status"
                  options={statusOptions}
                  value={filters.status}
                  onChange={(value) => handleFilterChange('status', value)}
                  labelKey="label"
                  valueKey="id"
                  placeholder="All Status"
                />

                <SelectDropdown
                  label="Role"
                  options={roles}
                  value={filters.role}
                  onChange={(value) => handleFilterChange('role', value)}
                  labelKey="roleName"
                  valueKey="_id"
                  placeholder="All Roles"
                  searchable
                />

                <SelectDropdown
                  label="Division"
                  options={divisions}
                  value={filters.divisionId}
                  onChange={(value) => handleFilterChange('divisionId', value)}
                  labelKey="name"
                  valueKey="_id"
                  placeholder="All Divisions"
                  searchable
                />

                <SelectDropdown
                  label="Department"
                  options={departments}
                  value={filters.departmentId}
                  onChange={(value) => handleFilterChange('departmentId', value)}
                  labelKey="name"
                  valueKey="_id"
                  placeholder="All Departments"
                  searchable
                />

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Start Date
                  </label>
                  <input
                    type="date"
                    name="startDate"
                    value={filters.startDate}
                    onChange={(e) => handleFilterChange('startDate', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    End Date
                  </label>
                  <input
                    type="date"
                    name="endDate"
                    value={filters.endDate}
                    onChange={(e) => handleFilterChange('endDate', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
                  />
                </div>

                <div className="sm:col-span-2 flex items-end gap-2">
                  <button
                    onClick={fetchInvitations}
                    className="px-6 py-2 bg-gradient-to-r from-red-500 to-pink-500 text-white rounded-lg hover:from-red-600 hover:to-pink-600 transition-all transform hover:scale-105 shadow-lg"
                  >
                    Apply Filters
                  </button>
                  <button
                    onClick={handleResetFilters}
                    className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-all"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Bulk Actions */}
        {selectedInvitations.length > 0 && (
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <span className="text-blue-700 font-medium">
                {selectedInvitations.length} invitation(s) selected
              </span>
            </div>
            <div className="flex gap-2">
              <button 
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                onClick={() => {
                  toast.info('Bulk resend feature coming soon');
                }}
              >
                Resend Selected
              </button>
              <button 
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
                onClick={() => {
                  toast.info('Bulk cancel feature coming soon');
                }}
              >
                Cancel Selected
              </button>
            </div>
          </div>
        )}

        {/* Table */}
        {filteredInvitations.length === 0 && !loading ? (
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-12 text-center">
            <FaEnvelope className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              No invitations found
            </h3>
            <p className="text-gray-500 mb-6">
              {searchTerm 
                ? "Try adjusting your search or filters"
                : "Start inviting team members to collaborate"
              }
            </p>
            <button
              disabled
              onClick={() => navigate(`/${portalName}/invitations/invite`)}
              className="px-6 py-3 bg-gradient-to-r from-red-500 to-pink-500 text-white rounded-lg hover:from-red-600 hover:to-pink-600 transition-all transform hover:scale-105 shadow-lg"
            >
              Invite Team Member
            </button>
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full min-w-[1400px] relative">
                <thead className="bg-gradient-to-r from-red-50 to-pink-50 border-b">
                  <tr>
                    <th className="sticky left-0 z-10 bg-gradient-to-r from-red-50 to-pink-50">
                      <div className="px-4 sm:px-6 py-3 flex items-center">
                        <input
                          type="checkbox"
                          checked={selectedInvitations.length === filteredInvitations.length && filteredInvitations.length > 0}
                          onChange={handleSelectAll}
                          className="w-4 h-4 text-red-600 border-gray-300 rounded focus:ring-red-500"
                        />
                        <span className="ml-4 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                          User
                        </span>
                      </div>
                    </th>
                    <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Contact
                    </th>
                    <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Role
                    </th>
                    <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Department
                    </th>
                    <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Division
                    </th>
                    <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Status
                    </th>
                    <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Invited By
                    </th>
                    <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                      <div className="flex items-center gap-1">
                        <Calendar className="h-3.5 w-3.5" />
                        Dates
                      </div>
                    </th>
                    <th className="px-4 sm:px-6 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {filteredInvitations.map((invitation) => (
                    <tr key={invitation._id} className="hover:bg-gray-50 transition-colors">
                      <td className="sticky left-0 z-10 bg-white">
                        <div className="px-4 sm:px-6 py-4 flex items-center">
                          <input
                            type="checkbox"
                            checked={selectedInvitations.includes(invitation._id)}
                            onChange={() => toggleSelection(invitation._id)}
                            className="w-4 h-4 text-red-600 border-gray-300 rounded focus:ring-red-500"
                          />
                          <div className="ml-4 flex items-center">
                            {invitation.profilePicture ? (
                              <img
                                src={invitation.profilePicture}
                                alt={`${invitation.firstName} ${invitation.lastName}`}
                                className="w-10 h-10 rounded-full object-cover"
                              />
                            ) : (
                              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-red-500 to-pink-500 flex items-center justify-center text-white font-bold text-sm">
                                {getInitials(invitation.firstName, invitation.lastName)}
                              </div>
                            )}
                            <div className="ml-3 sm:ml-4">
                              <div className="text-sm font-medium text-gray-900">
                                {invitation.firstName} {invitation.lastName}
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-4 sm:px-6 py-4">
                        <div className="text-sm text-gray-900 flex items-center">
                          <Mail className="h-3.5 w-3.5 mr-1 text-gray-400" />
                          <span className="truncate max-w-[200px]">{invitation.email}</span>
                        </div>
                        {invitation.mobile && (
                          <div className="text-sm text-gray-500 flex items-center mt-1">
                            <Phone className="h-3.5 w-3.5 mr-1 text-gray-400" />
                            {invitation.mobile}
                          </div>
                        )}
                      </td>
                      <td className="px-4 sm:px-6 py-4 whitespace-nowrap">
                        <span className={`px-2 sm:px-3 py-1 text-xs font-medium rounded-full border ${getRoleBadgeColor(invitation.role)}`}>
                          {invitation.role}
                        </span>
                      </td>
                      <td className="px-4 sm:px-6 py-4">
                        <div className="text-sm text-gray-900 flex items-center">
                          <Building className="h-3.5 w-3.5 mr-1 text-gray-400" />
                          {invitation.departmentId?.name || '-'}
                        </div>
                      </td>
                      <td className="px-4 sm:px-6 py-4">
                        <div className="text-sm text-gray-900 flex items-center">
                          <Briefcase className="h-3.5 w-3.5 mr-1 text-gray-400" />
                          {invitation.divisionId?.name || '-'}
                        </div>
                      </td>
                      <td className="px-4 sm:px-6 py-4 whitespace-nowrap">
                        {getStatusBadge(invitation.status)}
                      </td>
                      <td className="px-4 sm:px-6 py-4">
                        <div className="text-sm space-y-1">
                          <div className="text-gray-900 flex items-center">
                            <UserPlus className="h-3.5 w-3.5 mr-1 text-gray-400" />
                            <span className="text-xs">
                              {invitation.invitedBy?.firstName} {invitation.invitedBy?.lastName}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td className="px-4 sm:px-6 py-4">
                        <div className="text-sm space-y-1">
                          <div className="text-gray-700">
                            Invited: {formatDateTime(invitation.createdAt, false)}
                          </div>
                          {invitation.status === 'pending' && (
                            <div className="text-orange-600 text-xs">
                              Expires: {formatDateTime(invitation.expiresAt, false)}
                            </div>
                          )}
                          {invitation.status === 'accepted' && invitation.acceptedAt && (
                            <div className="text-green-600 text-xs">
                              Accepted: {formatDateTime(invitation.acceptedAt, false)}
                            </div>
                          )}
                        </div>
                      </td>
                      <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-center">
                        <div className="relative dropdown-container">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setShowDropdown(showDropdown === invitation._id ? null : invitation._id);
                            }}
                            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                          >
                            <MoreVertical className="h-5 w-5 text-gray-500" />
                          </button>
                          
                          {showDropdown === invitation._id && (
                            <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border z-20">
                              {invitation.status === 'pending' && (
                                <button
                                  onClick={() => handleResendInvitation(invitation._id)}
                                  className="flex items-center gap-2 w-full px-4 py-2 text-sm text-blue-700 hover:bg-gray-50 rounded-t-lg"
                                >
                                  <FaRedo className="h-4 w-4" />
                                  Resend Invitation
                                </button>
                              )}
                              <button
                                onClick={() => handleCancelInvitation(invitation._id)}
                                className={`flex items-center gap-2 w-full px-4 py-2 text-sm text-red-700 hover:bg-gray-50 ${
                                  invitation.status !== 'pending' ? 'rounded-lg' : 'rounded-b-lg'
                                }`}
                              >
                                <FaTrash className="h-4 w-4" />
                                Cancel Invitation
                              </button>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            {/* Mobile scroll indicator */}
            <div className="sm:hidden bg-gray-50 px-4 py-2 text-center text-xs text-gray-500">
              ← Scroll horizontally to see more →
            </div>
          </div>
        )}

        {/* Pagination */}
        {filteredInvitations.length > 0 && (
          <div className="mt-8">
            <Pagination
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
              onItemsPerPageChange={(value) => {
                setItemsPerPage(value);
                setCurrentPage(1);
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default InvitationPage;
